import type { InvSlot } from '../inventory/Grid';

const LABELS: Record<string, string> = {
  wood: 'Wood',
  fiber: 'Fiber',
  leather: 'Leather',
  spear: 'Spear',
  bow: 'Bow',
  torch: 'Torch',
  shovel: 'Shovel',
  rope: 'Rope',
  tracker: 'Dinosaur tracker',
  axe: 'Stone axe',
  metal_axe: 'Metal axe',
  sling: 'Slingshot',
  compass: 'Compass',
  raw: 'Raw meat',
  cooked: 'Cooked meat',
};

let inFrame = false;
let frameBest = '';

/** Call once at the start of a sim tick so later empty writers cannot wipe a real prompt. */
export function beginPromptFrame(): void {
  inFrame = true;
  frameBest = '';
}

export function endPromptFrame(): void {
  inFrame = false;
  paintPrompt(frameBest);
}

export function setPrompt(text: string): void {
  if (inFrame) {
    if (text.length > 0 && frameBest.length === 0) {
      frameBest = text;
    }
    return;
  }
  paintPrompt(text);
}

function paintPrompt(text: string): void {
  const el = ensureEl('prompt', 'Interact');
  el.textContent = text;
  el.hidden = text.length === 0;
}

export function setInvHud(stacks: readonly InvSlot[]): void {
  const el = ensureEl('inv', 'Inventory');
  el.textContent = stacks.map(formatStack).join('  ·  ');
  el.hidden = stacks.length === 0;
}

function formatStack(slot: InvSlot): string {
  const name = LABELS[slot.id] ?? slot.id;
  return slot.count > 1 ? `${name} ×${slot.count}` : name;
}

function ensureEl(id: string, label: string): HTMLElement {
  const existing = document.getElementById(id);
  if (existing) {
    return existing;
  }
  const el = document.createElement('div');
  el.id = id;
  el.setAttribute('data-hud', id);
  el.setAttribute('aria-label', label);
  if (id === 'prompt') {
    el.setAttribute('aria-live', 'polite');
  }
  const host = document.getElementById('ui-root') ?? document.body;
  host.append(el);
  return el;
}
